import {
  setIsLoadingTariffList,
  setIsLoadingTariffDetails,
  setSuccessTariffDetails,
  setSuccessTariffList,
  setTariffDetailsError,
  setTariffListError
} from './tariff-information-slice';
import { getTariffDetails, getTariffList } from 'api/tariff-information';
import { getErrors } from 'api/client';

export const ErrorMissingTariffs = {
  message: 'Gas and electricity tariffs are missing'
};

export const getTariffListThunk = ({
  requestConfig,
  fuel,
  paymentMethod,
  postcode
}) => async (dispatch) => {
  try {
    dispatch(setIsLoadingTariffList());
    const response = await getTariffList({
      requestConfig,
      fuel,
      paymentMethod,
      postcode
    });

    dispatch(setSuccessTariffList(response));
    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setTariffListError(errors));

    return Promise.reject(errors);
  }
};

export const getTariffDetailsThunk = ({
  tariffId,
  paymentMethod,
  economy7,
  isTOU,
  fuel,
  postcode,
  requestConfig
}) => async (dispatch) => {
  try {
    dispatch(setIsLoadingTariffDetails());
    const response = await getTariffDetails({
      tariffId,
      paymentMethod,
      economy7,
      isTOU,
      fuel,
      postcode,
      requestConfig
    });

    if (!response.data.tariffs.length) {
      const errors = [ErrorMissingTariffs];

      dispatch(setTariffDetailsError(errors));
      return Promise.reject(errors);
    }
    dispatch(setSuccessTariffDetails(response));
    return Promise.resolve(response);
  } catch (e) {
    const errors = getErrors(e);
    errors && dispatch(setTariffDetailsError(errors));

    return Promise.reject(errors);
  }
};
